<template>
  <div class="pc_out_container" ref="layoutRef">
    <!--  顶部导航栏 -->
    <div
      v-if="$route.meta.type !== 'my' && !$route.meta.hideLayoutTop"
      :key="'layout-top-' + $route.fullPath"
      class="layout_top"
      :style="layoutTopStyle"
      :class="{
        'home-compact': isHomeRoute && homeNavCompact,
        'home-edge-layout': isHomeRoute && !homeNavCompact,
        'transparent-scrolled': $route.meta.transparentNav && isScrolled,
        'is-wiki-nav': isWikiNav,
        'wiki-scrolled': isWikiRoute && isScrolled,
      }"
    >
      <div class="layout_top_text">
        <div class="layout_top_text_inner">
          <img
            v-if="!isHomeRoute || homeNavCompact"
            :src="homeLogoSrc"
            :alt="navLogoTitle"
            class="logo_img home-compact-logo"
            :class="navLogoClass"
            @click="handleLogoClick()"
          />
          <!-- 导航菜单区域 -->
          <div
            v-show="!isHomeRoute || !homeNavCompact"
            class="nav-container"
            :style="{ color: navTextColor }"
          >
            <template v-for="(item, index) in visibleNavList">
              <div
                class="nav-item"
                :key="'nav-' + item.url + index"
                :class="{
                  active: isNavItemActive(item),
                  'no-active-indicator': item.url === '/pc/wiki/questions',
                }"
                @click="handleNavClick(item)"
              >
                <span>{{ displayNavTitle(item) }}</span>
              </div>
            </template>
          </div>
        </div>
        <div
          class="pc-search-box"
          v-if="$route.meta.showSearch && (!isHomeRoute || homeNavCompact)"
        >
          <!-- 搜索料号、名称 -->
          <!-- 先搜一下 -->
          <SearchBox
            class="pc-top-search"
            :placeholder="$t('common.searchPlaceholder')"
            :button-text="$t('common.searchAction')"
            :input-bg-color="searchInputBg"
            shape="round"
            @search="onProductSearch"
          />
        </div>
        <GeneralAgentServiceTrigger />
        <LocaleSwitcher compact class="pc-ui-locale" />
        <div class="me pc-login-area" v-if="$route.meta.showUserInfo">
          <div v-if="userInfo.token">
            <span>
              <router-link to="/pc/user" class="pc-account-link">{{
                userInfo.authnName ? userInfo.authnName : userInfo.nick_name
              }}</router-link>
            </span>
            <!-- 退出 -->
            <a @click="logout" class="clickable">{{ $t('common.logout') }}</a>
          </div>
          <div v-else class="login-btns">
            <!-- 登录 -->
            <a @click="openLoginDialog('sms')" class="clickable pc-login-btn">{{
              $t('common.login')
            }}</a>
            <!-- 注册 -->
            <a
              @click="openLoginDialog('register')"
              class="clickable pc-register-btn"
              >{{ $t('common.register') }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 个人中心顶部导航 -->
    <div
      v-if="$route.meta.type == 'my' && !$route.meta.hideLayoutTop"
      class="layout_top_my"
      :style="{
        background: $route.meta.backgroundColor || '#ffffff',
      }"
    >
      <div class="layout_top_text">
        <div class="layout_top_text_inner">
          <img
            :src="homeLogoSrc"
            :alt="navLogoTitle"
            class="logo_img home-compact-logo"
            :class="navLogoClass"
            @click="handleLogoClick"
          />
          <!-- 导航菜单区域 -->
          <div
            class="nav-container"
            :style="{ color: $route.meta.textColor || 'rgba(59, 59, 59, 0.8)' }"
          >
            <template v-for="(item, index) in visibleNavList">
              <div
                class="nav-item"
                :key="'nav-my-' + item.url + index"
                :class="{
                  active: isNavItemActive(item),
                  'no-active-indicator': item.url === '/pc/wiki/questions',
                }"
                @click="handleNavClick(item)"
              >
                <span>{{ displayNavTitle(item) }}</span>
              </div>
            </template>
          </div>
        </div>
        <GeneralAgentServiceTrigger />
        <LocaleSwitcher compact class="pc-ui-locale" />
        <div class="me pc-login-area" v-if="$route.meta.showUserInfo">
          <div v-if="userInfo.token">
            <span>
              <router-link to="/pc/user" class="pc-account-link">{{
                userInfo.authnName ? userInfo.authnName : userInfo.nick_name
              }}</router-link>
            </span>
            <!-- 退出 -->
            <a @click="logout" class="clickable">{{ $t('common.logout') }}</a>
          </div>
          <div v-else class="login-btns">
            <!-- 登录 -->
            <a @click="openLoginDialog('sms')" class="clickable pc-login-btn">{{
              $t('common.login')
            }}</a>
            <!-- 注册 -->
            <a
              @click="openLoginDialog('register')"
              class="clickable pc-register-btn"
              >{{ $t('common.register') }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <AuthDialog
      :visible.sync="dialogVisible"
      :initial-mode="authInitialMode"
      :initial-login-mode="activeTab"
    />

    <!-- 路由视图 -->
    <!-- <router-view
      v-if="$route.path === '/pc/bindGoods'"
      @openLoginDialog="openLoginDialog"
    ></router-view>
    <router-view v-else></router-view> -->
    <!--
      百科列表进入详情后保留组件实例，使浏览器返回时仍有离开前的
      筛选、分页和页面高度，Vue Router 才能准确恢复 savedPosition。
      include 只匹配 WikiPage，不缓存详情页或其他频道。
    -->
    <keep-alive include="WikiPage">
      <router-view
        ref="pageView"
        v-bind="$route.meta.searchResultHeader ? { navigationLogoSrc: homeLogoSrc, navigationLogoAlt: navLogoTitle } : {}"
        @openLoginDialog="openLoginDialog"
        @product-search="onProductSearch"
        @home-nav-compact-change="handleHomeNavCompactChange"
      ></router-view>
    </keep-alive>
  </div>
</template>

<script>
import devSyncI18n from '@/i18n/common/index';

import { withPriceChannelTopNavigation } from "@/services/price-channel/business-navigation";
import {
  getPicCode,
  getMsgCode,
  codeLogin,
  passwordLogin as passwordLoginApi,
  registerUser,
  wxLogin,
  getWxmpCode,
  selectWxmpLoginStatus,
  bindMobile,
} from "@/api/login";
import { getBannerAdv } from "@/api/home";
import SearchBox from "@/components/pc/SearchBox.vue";
import LocaleSwitcher from "@/components/common/LocaleSwitcher.vue";
import GeneralAgentServiceTrigger from "@/components/agent-service/GeneralAgentServiceTrigger.vue";
import { navigationMessageKey } from "@/i18n/catalog";
import AuthDialog from "@/views/pc/layout/components/AuthDialog.vue";
import { getUserInfoDetail } from "@/api/user.js";
import { encryptPassword } from "@/utils/passwordEncrypt";

import { Toast } from "vant";
import { mapState } from "vuex";
import { resolveHomeDoodle } from "@/indexlogo/schedule";

export default {
  mixins: [devSyncI18n],
  name: "layoutIndex",
  components: {
    SearchBox,
    LocaleSwitcher,
    GeneralAgentServiceTrigger,
    AuthDialog,
  },
  data() {
    return {
      navList: [], //处理数据结构的底部导航栏数据
      logoList: [], //logo列表
      bannerNavList: [], //下方导航列表（有图片）
      picCode: "", //用户输入的图像验证码
      picKey: "", //请求传递的图形验证码唯一标识
      picUrl: "", //存储请求渲染的图片地址
      totalSecond: 60, //总秒数
      second: 60, //当前秒数 开定时器
      time1: null, //定时器id 微信登录二维码
      time2: null, //定时器id 短信验证码
      // mobile: "15818590119", //手机号
      // msgCode: "1234", //短信验证码
      mobileCountryCode: "+86",
      mobile: "",
      msgCode: "1234",
      countryCodeOptions: [
        { label: "+86 China", shortLabel: "+86", code: "+86" },
        { label: "+852 Hong Kong", shortLabel: "+852", code: "+852" },
        { label: "+853 Macao", shortLabel: "+853", code: "+853" },
        { label: "+886 Taiwan", shortLabel: "+886", code: "+886" },
        { label: "+1 United States / Canada", shortLabel: "+1", code: "+1" },
        { label: "+44 United Kingdom", shortLabel: "+44", code: "+44" },
        { label: "+61 Australia", shortLabel: "+61", code: "+61" },
        { label: "+65 Singapore", shortLabel: "+65", code: "+65" },
        { label: "+60 Malaysia", shortLabel: "+60", code: "+60" },
        { label: "+81 Japan", shortLabel: "+81", code: "+81" },
        { label: "+82 South Korea", shortLabel: "+82", code: "+82" },
        { label: "+66 Thailand", shortLabel: "+66", code: "+66" },
        { label: "+84 Vietnam", shortLabel: "+84", code: "+84" },
        { label: "+62 Indonesia", shortLabel: "+62", code: "+62" },
        { label: "+63 Philippines", shortLabel: "+63", code: "+63" },
      ],
      loginAccount: "",
      loginPassword: "",
      rememberMe: true,
      registerType: "personal",
      personalForm: {
        countryCode: "+86",
        mobile: "",
        smsCode: "1234",
        username: "",
        password: "",
      },
      enterpriseForm: {
        companyName: "",
        creditCode: "",
        email: "",
        emailCode: "",
        contactPhone: "",
        smsCode: "",
        contactName: "",
        password: "",
      },
      registerAgreement: false,
      registerSecond: 60,
      registerTimer: null,
      isAgree: false, // 协议勾选状态
      dialogVisible: false, // 登录弹窗状态
      authInitialMode: "login",
      wxLoginUrl: "", //pc端微信登录地址
      activeTab: "sms", // 登录方式，默认短信登录
      status: "", // 扫码状态
      wxLoginUuid: "", // 微信扫码登录uuid
      ticket: "", // 扫码票据
      token: "", // 扫码成功后返回的token
      isInvalid: false, // 登录是否失效
      isScrolled: false, // 顶部导航滚动状态
      homeNavCompact: false, // 首页独立的紧凑导航状态
      startTime: "", // 登录失效开始时间
      timeoutDuration: 1000 * 60 * 5, // 登录失效时间 5分钟
      loginSubmitting: false,
      activeNavDoodle: null,
      navDoodleTimer: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userDetails,
      userShopInfo: (state) => state.user.userInfo,
    }),
    homeLogoSrc() {
      if (this.activeNavDoodle?.navImage) return this.activeNavDoodle.navImage;
      return (
        this.logoList[0]?.image || require("@/assets/pc/home-search-logo.png")
      );
    },
    navLogoTitle() {
      if (this.activeNavDoodle) return `先搜${this.activeNavDoodle.name}标志`;
      return this.logoList[0]?.title || "先搜";
    },
    navLogoClass() {
      const key = this.activeNavDoodle?.key;
      return {
        "festival-nav-logo": Boolean(key),
        "mid-autumn-nav-logo": this.activeNavDoodle?.themeKey === "mid-autumn",
        "national-day-nav-logo":
          this.activeNavDoodle?.themeKey === "national-day",
      };
    },
    isHomeRoute() {
      return (
        this.$route.path === "/pc/home" ||
        this.$route.path === "/pc/featured" ||
        this.$route.path === "/"
      );
    },
    isPrimaryHomeRoute() {
      return this.$route.path === "/pc/home" || this.$route.path === "/";
    },
    visibleNavList() {
      return this.navList;
    },
    isWikiNav() {
      return this.$route.meta.navVariant === "wiki";
    },
    isWikiRoute() {
      return this.$route.path === "/pc/wiki";
    },
    isEditPublishRoute() {
      return (
        this.$route.path.includes("/source/publish") &&
        this.$route.query.mode === "edit"
      );
    },
    layoutTopStyle() {
      return {
        background: this.$route.meta.transparentNav
          ? this.isScrolled
            ? "#ffffff"
            : "transparent"
          : this.$route.meta.backgroundColor || "#ffffff",
      };
    },
    navTextColor() {
      return this.$route.meta.textColor || "rgba(59, 59, 59, 0.8)";
    },
    searchInputBg() {
      return this.isWikiNav ? "rgba(255, 255, 255, 0.2)" : "#f4f4f6";
    },
  },
  created() {
    this.refreshNavDoodle();
    this.navDoodleTimer = window.setInterval(this.refreshNavDoodle, 10 * 1000);
    // 所有 PC 页面统一由公共布局恢复登录前待处理的搜索。
    this.resumePendingSearchAfterLogin();
    this.getNavList();
    this.getHomeLogoList();
    if (typeof window !== "undefined") {
      window.addEventListener("open-login-dialog", this.openLoginDialog);
    }
  },
  mounted() {
    const container = this.$refs.layoutRef;
    if (container) {
      container.addEventListener("scroll", this.handleScroll);
    }
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("open-login-dialog", this.openLoginDialog);
      window.removeEventListener("scroll", this.handleScroll);
    }
    const container = this.$refs.layoutRef;
    if (container) {
      container.removeEventListener("scroll", this.handleScroll);
    }
    this.clearPolling("time1");
    this.clearPolling("time2");
    this.clearPolling("registerTimer");
    window.clearInterval(this.navDoodleTimer);
  },
  watch: {
    // 监听登录状态，重新加载导航数据
    userInfo: {
      handler(newVal) {
        this.getNavList();
      },
      deep: true, // 开启深度观察，确保对象内部属性变化也能触发更新
    },
    $route: {
      handler(newVal) {
        this.refreshNavDoodle();
        this.isScrolled = false;
        this.homeNavCompact = false;
        this.saveReferralParams(newVal?.query);
        this.openLoginDialogByRoute(newVal);
      },
      immediate: true,
      deep: true, // 开启深度观察，确保对象内部属性变化也能触发更新
    },
  },

  methods: {
    displayNavTitle(item) {
      const key = navigationMessageKey(this.normalizeNavUrl(item), item?.title);
      // 旧版导航接口可能返回非标准发布 URL；仅按固定标题兜底翻译展示，不改跳转地址。
      return key
        // 动态简中示例：按 navigationMessageKey 的路由／标题映射取词；未知导航保留原名；完整中文见对应 zh-CN.js，示例不代表固定返回值
        // nav.home：首页
        // nav.publish：发布
        // nav.featured：精选
        // nav.bidding：竞标
        // nav.supply：供需
        // nav.wiki：百科
        ? this.$t(key)
        : String(item?.title || "").trim() === "发布"
          // 发布
          ? this.$t("nav.publish")
          : item?.title || "";
    },
    refreshNavDoodle() {
      const browserOverride = new URLSearchParams(window.location.search).get(
        "doodle",
      );
      this.activeNavDoodle = resolveHomeDoodle(
        new Date(),
        this.$route?.query?.doodle || browserOverride || "",
      );
    },
    getHomeLogoList() {
      this.queryBannerAdv(
        { which: 1, type: 1, position: "HOME", status: 0 },
        (res) => {
          if (res.code === 200 && Array.isArray(res.data) && res.data.length) {
            this.logoList = [...res.data].sort((a, b) => a.sort - b.sort);
          }
        },
      );
    },
    openLoginDialogByRoute(route) {
      if (!route || !route.query?.backUrl || this.userInfo?.token) {
        return;
      }
      // 公开搜索的返回地址只是导航上下文，不能据此要求登录。
      if (["/pc/search", "/pc/myAi"].includes(route.path)) return;
      if (
        route.path === "/pc/myxg/myTransactionOrder" ||
        route.path === "/pc/myxg/myTransactionOrderDetail"
      ) {
        return;
      }
      this.openLoginDialog();
    },
    // 获取菜单数据
    getNavList() {
      this.queryBannerAdv(
        { which: 1, type: 5, position: "LAYOUT", status: 0 },
        (res) => {
          // 解构赋值简化数据访问
          const { code, data = [] } = res || {};

          // 初始化navList（处理接口异常或无数据的情况）
          this.navList = [];
          // 仅在接口成功且有数据时处理
          if (code === 200 && data.length) {
            // 先排序再过滤状态有效的项（基础处理）
            let processedList = data
              .sort((a, b) => a.sort - b.sort) // 按sort升序排列
              .filter((item) => item.status === 0); // 过滤出状态为0的项 0: 有效，1: 无效
            // 根据登录状态处理用户中心显示
            if (!this.userInfo.token) {
              // 未登录：过滤掉用户中心入口
              processedList = processedList.filter(
                (item) => item.url !== "/pc/user",
              );
            }
            // 本地和正式环境均隐藏“知道”频道入口。
            processedList = processedList.filter((item) => {
              const title = String(item.title || "").trim();
              const path = String(this.normalizeNavUrl(item) || "")
                .split(/[?#]/)[0]
                .replace(/\/$/, "");
              return (
                title !== "知道" &&
                !["/pc/wiki/questions", "/pc/wiki/community"].includes(path)
              );
            });
            this.navList = withPriceChannelTopNavigation(processedList);
          } else {
            this.navList = withPriceChannelTopNavigation([]);
          }
        },
      );
    },
    // 打开pc登录弹窗
    openLoginDialog(tab = "sms") {
      if (typeof tab === "string") {
        this.activeTab = tab;
        this.authInitialMode = tab === "register" ? "register" : "login";
      }
      this.dialogVisible = true;
      if (this.activeTab === "wechat") {
        this.getWxmpCode();
      } else {
        // this.getPicCode();
      }
    },
    // 关闭弹窗
    handleClose() {
      console.log("关闭弹窗");
      this.dialogVisible = false;
      this.clearPolling("time1"); // 关闭弹窗时清除定时器1
      this.clearPolling("time2"); // 关闭弹窗时清除定时器2
      this.clearPolling("registerTimer");
      this.wxLoginUuid = "";
      this.ticket = "";
      this.wxLoginUrl = "";
      this.isInvalid = false;
    },
    //切换登录方式
    handleClick(tab) {
      this.activeTab = tab.name;
      this.clearPolling("time1"); //切换登录方式时清除定时器1
      if (tab.name === "wechat") {
        this.getWxmpCode();
      }
      if (
        tab.name === "sms" ||
        tab.name === "password" ||
        tab.name === "register"
      ) {
        this.clearPolling("time1"); //切换登录方式时清除定时器1
        // this.getPicCode();
      }
    },
    validMobile() {
      return this.validMobileValue(this.mobile, this.mobileCountryCode);
    },
    validMobileValue(mobile, countryCode = "+86") {
      const value = String(mobile || "");
      if (countryCode === "+86" && !/^1[3-9]\d{9}$/.test(value)) {
        // 请输入正确的手机号
        this.$toast(this.$t("auth.invalidMobile"));
        return false;
      }
      // 海外号码规则差异大，先只限制数字和长度，具体号段留给短信通道兜底。
      if (countryCode !== "+86" && !/^\d{6,20}$/.test(value)) {
        // 请输入6-20位数字手机号
        this.$toast(this.$t("auth.invalidOverseasMobile"));
        return false;
      }
      // if (!/^\w{4}$/.test(this.picCode)) {
      //   this.$toast("请输入正确的图形验证码");
      //   return false;
      // }
      return true;
    },
    // 获取短信验证码
    async getCode() {
      if (!this.validMobile()) {
        //如果没通过校验 没必要继续往下走
        return;
      }
      if (!this.time2 && this.second === this.totalSecond) {
        // await getMsgCode(this.picCode, this.picKey, this.mobile);
        await getMsgCode(this.mobile, this.mobileCountryCode, "login");
        // 短信已发送,注意查收
        this.$toast(this.$t("realname.smsSent"));
        // 开启定时器
        this.time2 = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            this.clearPolling("time2");
            this.second = this.totalSecond; //重置时间
          }
        }, 1000);
      }
    },
    async getRegisterCode() {
      const mobile =
        this.registerType === "personal"
          ? this.personalForm.mobile
          : this.enterpriseForm.contactPhone;
      const countryCode =
        this.registerType === "personal"
          ? this.personalForm.countryCode
          : "+86";
      if (!this.validMobileValue(mobile, countryCode)) return;
      if (!this.registerTimer && this.registerSecond === this.totalSecond) {
        await getMsgCode(mobile, countryCode, "register");
        // 短信已发送,注意查收
        this.$toast(this.$t("realname.smsSent"));
        this.registerTimer = setInterval(() => {
          this.registerSecond--;
          if (this.registerSecond <= 0) {
            this.clearPolling("registerTimer");
            this.registerSecond = this.totalSecond;
          }
        }, 1000);
      }
    },
    getEnterpriseEmailCode() {
      if (!this.enterpriseForm.email) {
        // 请输入企业邮箱
        this.$toast(this.$t("devUpdates.enterTheBusinessEmail"));
        return;
      }
      this.$toast(this.devSyncText("验证码暂未接入，先填任意4位数字"));
    },
    // 获取图形验证码
    async getPicCode() {
      const {
        data: { base64, key },
      } = await getPicCode();
      this.picUrl = base64; //存储地址
      this.picKey = key; //存储唯一标识

      // this.$toast.success('成功文案')
    },
    //生成uuid
    generateSimpleUUID() {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    },
    // 获取微信扫码登录二维码url
    getWxmpCode() {
      this.clearPolling("time1");
      this.ticket = "";
      this.wxLoginUrl = "";
      this.isInvalid = false;
      //通过方法获取自己生成的uuid
      const uuid = this.generateSimpleUUID();
      this.wxLoginUuid = uuid;
      getWxmpCode(uuid)
        .then((res) => {
          if (res.code === 200) {
            const { url, ticket } = JSON.parse(res.msg);
            if (!ticket) {
              throw new Error("微信登录二维码缺少ticket");
            }
            this.ticket = ticket;
            this.wxLoginUrl = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`;
            this.startTime = Date.now(); //记录登录开始时间
            this.startPolling();
          } else {
            throw new Error(res.msg || "请求异常！");
          }
        })
        .catch((error) => {
          const errorMsg =
            error.response?.data?.msg || error.message || "请求异常！";
          this.$toast(errorMsg);
        });
    },
    //开始轮询
    startPolling() {
      if (!this.ticket || !this.wxLoginUuid) {
        return;
      }
      this.clearPolling("time1");
      this.time1 = setInterval(() => {
        const now = Date.now();
        const duration = now - this.startTime;
        if (duration >= this.timeoutDuration) {
          this.isInvalid = true;
          this.clearPolling("time1"); //失效后停止轮训
          return;
        }
        //调取轮询接口
        this.selectWxmpLoginStatus();
      }, 3000);
    },
    // 轮询扫码状态
    async selectWxmpLoginStatus() {
      if (!this.ticket || !this.wxLoginUuid) {
        this.clearPolling("time1");
        return;
      }
      const res = await selectWxmpLoginStatus(this.wxLoginUuid, this.ticket);
      if (res.code === 200) {
        if (res.data.token) {
          // this.token = res.data.token;
          this.clearPolling("time1"); // 扫码成功后停止轮训
          this.updateUserInfo(res.data);
        }
      } else {
        // 请求异常！
        Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
      }
    },
    // 清除轮训定时器
    clearPolling(timerRef) {
      if (typeof timerRef !== "string") {
        if (timerRef) {
          clearInterval(timerRef);
        }
        return;
      }
      const timerId = this[timerRef];
      if (timerId) {
        clearInterval(timerId);
        this[timerRef] = null;
      }
    },
    // 刷新二维码
    refreshQrcode() {
      this.isInvalid = false;
      this.getWxmpCode();
    },
    switchToWechatLogin() {
      this.activeTab = "wechat";
      this.getWxmpCode();
    },
    // 登录
    handleLoginEnter() {
      if (this.dialogVisible && this.activeTab === "sms") {
        this.login();
      }
      if (this.dialogVisible && this.activeTab === "password") {
        this.passwordLogin();
      }
    },
    async passwordLogin() {
      if (!this.loginAccount || !this.loginPassword) {
        // 请填写账号和密码
        this.$toast(this.$t("devUpdates.enterTheAccountAndPassword"));
        return;
      }
      const encryptedPassword = await encryptPassword(this.loginPassword);
      const res = await passwordLoginApi(this.loginAccount, encryptedPassword);
      if (res.code == 200) {
        this.updateUserInfo(res.data);
      } else {
        // 请求异常！
        Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
      }
    },
    async register() {
      if (!this.registerAgreement) {
        // 请阅读并同意相关协议
        this.$toast(this.$t("devUpdates.readAndAcceptTheAgreements"));
        return;
      }
      const form =
        this.registerType === "personal"
          ? this.personalForm
          : this.enterpriseForm;
      const mobile = form.mobile || form.contactPhone;
      const countryCode =
        this.registerType === "personal"
          ? this.personalForm.countryCode
          : "+86";
      if (!this.validMobileValue(mobile, countryCode)) return;
      const code =
        this.registerType === "enterprise" ? form.emailCode : form.smsCode;
      if (!/^\d{4}$/.test(code)) {
        // 请输入4位数字验证码
        this.$toast(this.$t("auth.invalidFourDigitCode"));
        return;
      }
      if (
        !form.password ||
        form.password.length < 6 ||
        form.password.length > 20
      ) {
        // 密码长度需为6-20位
        this.$toast(this.$t("devUpdates.thePasswordMustContain620Characters"));
        return;
      }
      if (this.registerType === "enterprise" && !form.companyName) {
        // 请填写企业全称
        this.$toast(this.$t("devUpdates.enterTheFullCompanyName"));
        return;
      }
      const res = await registerUser({
        registerType: this.registerType,
        countryCode,
        mobile,
        smsCode: code,
        emailCode: form.emailCode,
        username: form.username || form.contactName,
        password: await encryptPassword(form.password),
        companyName: form.companyName,
        creditCode: form.creditCode,
        email: form.email,
        contactName: form.contactName,
        contactPhone: form.contactPhone,
        role: "buyer",
        ...this.getReferralParams(),
      });
      if (res.code == 200) {
        this.clearReferralParams();
        this.updateUserInfo(res.data);
      } else {
        // 请求异常！
        Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
      }
    },
    forgotPassword() {
      // 请先使用短信登录，登录后在个人中心修改密码
      this.$toast(this.$t("mobileLogin.forgotPasswordHint"));
    },
    parseQueryFromUrl(url) {
      if (!url) return {};
      try {
        const target = new URL(url, window.location.origin);
        return Object.fromEntries(target.searchParams.entries());
      } catch (e) {
        return {};
      }
    },
    saveReferralParams(query = {}) {
      const backQuery = this.parseQueryFromUrl(query.backUrl);
      const referrerId = query.referrerId || backQuery.referrerId;
      const inviteCode = query.inviteCode || backQuery.inviteCode;
      if (referrerId) localStorage.setItem("xsou_referrer_id", referrerId);
      if (inviteCode) localStorage.setItem("xsou_invite_code", inviteCode);
    },
    getReferralParams() {
      this.saveReferralParams(this.$route.query);
      return {
        referrerId:
          this.$route.query.referrerId ||
          localStorage.getItem("xsou_referrer_id"),
        inviteCode:
          this.$route.query.inviteCode ||
          localStorage.getItem("xsou_invite_code"),
      };
    },
    clearReferralParams() {
      localStorage.removeItem("xsou_referrer_id");
      localStorage.removeItem("xsou_invite_code");
    },
    async login() {
      if (this.loginSubmitting) {
        return;
      }
      if (!this.validMobile()) {
        return;
      }
      // if (!this.isAgree) {
      //   this.$toast("请阅读并同意相关协议");
      //   return;
      // }
      if (!/^\d{4}$/.test(this.msgCode)) {
        // 请输入正确的手机验证码
        this.$toast(this.$t("devUpdates.enterAValidMobileVerificationCode"));
        return;
      }
      try {
        this.loginSubmitting = true;
        const res = await codeLogin(
          this.mobile,
          this.msgCode,
          this.mobileCountryCode,
        );
        if (res.code == 200) {
          console.log("登录返回", res.data);
          this.updateUserInfo(res.data);
        } else {
          // 请求异常！
          Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
        }
      } finally {
        this.loginSubmitting = false;
      }
    },
    async updateUserInfo(data) {
      this.$store.commit("user/setUserInfo", data);
      try {
        const response = await getUserInfoDetail();
        if (response.code === 200 && response.data) {
          this.$store.commit(
            "user/setUserDetails",
            response.data.userInfo ?? {},
          );
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          this.dialogVisible = false;
          // 刷新当前页面
          this.$router.go(0);
        }
      } catch (error) {
        const errorMsg =
          error.response?.data?.msg || error.message || "请求异常！";
        this.$message({
          message: errorMsg,
          type: "error",
        });
      }
    },
    logout() {
      console.log("退出登录");
      this.$confirm(
        // 你确认要退出登录吗？
        this.$t("devUpdates.areYouSureYouWantToLogOut"),
        // 温馨提示
        this.$t("mobile.product.notice"),
        {
          // 确定
          confirmButtonText: this.$t("auth.confirm"),
          // 取消
          cancelButtonText: this.$t("business.cancel"),
          type: "warning",
        },
      )
        .then(() => {
          // 用户点击确定
          this.resetCurrentHomeScroll();
          this.$store.dispatch("user/logout");
          if (this.isHomeRoute) {
            window.location.reload();
          } else {
            this.$router.replace("/pc/home");
          }
        })
        .catch(() => {
          // 用户点击取消
          // 已取消退出
          this.$message.info(this.$t("devUpdates.logoutCancelled"));
        });
    },
    // 绑定手机号
    bindMobile() {
      bindMobile(this.mobile, this.msgCode).then((res) => {
        if (res.code === 200) {
          // 绑定成功
          this.$toast(this.$t("devUpdates.linkedSuccessfully"));
          console.log(res.data);
        } else {
          // 请求异常！
          Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
        }
      });
    },
    queryBannerAdv(params, callback) {
      getBannerAdv(params)
        .then((resp) => {
          callback(resp);
        })
        .catch((error) => {
          console.error("请求图片资源失败:", error);
        });
    },
    // 处理导航点击
    normalizeNavUrl(item) {
      const title = item && item.title ? String(item.title).trim() : "";
      const url = typeof item === "string" ? item : item && item.url;
      if (title === "知道") {
        return "/pc/wiki/questions";
      }
      const clueUrls = ["/info", "/pc/info", "/pc/supply-demand/hall"];
      if (title === "供需" || title === "供求" || clueUrls.includes(url)) {
        return "/pc/clue";
      }
      const publishPath = String(url || "").split(/[?#]/)[0];
      if (
        [
          "/source/publish",
          "/source/publish/fast",
          "/pc/source/publish",
          "/pc/source/publish/fast",
        ].includes(publishPath)
      ) {
        return "/pc/source/publish";
      }
      return url;
    },
    isNavItemActive(item) {
      const url = this.normalizeNavUrl(item);
      if (
        this.isEditPublishRoute &&
        String(url || "").includes("/source/publish")
      ) {
        return false;
      }
      if (String(url || "").includes("/source/publish")) {
        return this.$route.path.includes("/source/publish");
      }
      const homeUrls = ["/", "/pc", "/pc/home"];
      if (homeUrls.includes(url)) {
        return homeUrls.includes(this.$route.path);
      }
      if (url === "/pc/wiki") {
        return (
          this.$route.path === url || this.$route.path.startsWith(`${url}/`)
        );
      }
      if (url === "/pc/pricechannel/display") {
        return this.$route.path.startsWith("/pc/pricechannel/");
      }
      return this.$route.path === url;
    },
    handleNavClick(item) {
      const url = this.normalizeNavUrl(item);
      console.log("点击导航项:", url);
      if (this.isAuthPublishUrl(url) && !this.userInfo.token) {
        this.openLoginDialog();
        return;
      }
      if (url && this.$route.fullPath !== url) {
        this.$router.push(url);
      }
    },
    isAuthPublishUrl(url) {
      const path = String(url || "").split(/[?#]/)[0];
      return [
        "/source/publish",
        "/source/publish/fast",
        "/pc/source/publish",
        "/pc/source/publish/fast",
      ].includes(path);
    },
    onProductSearch(query) {
      const keyword = (query || "").trim();
      if (!keyword) return;

      // PC 搜索栏复用全站搜索页，和 /pc/search 的结果页保持一致。
      this.$router.push({
        path: "/pc/search",
        query: { keyword },
      });
    },
    resumePendingSearchAfterLogin() {
      const backUrl = this.$route.query.backUrl;
      if (!this.$store.getters.token || typeof backUrl !== "string") {
        return false;
      }

      const resolvedRoute = this.$router.resolve(backUrl).route;
      if (resolvedRoute.path !== "/pc/search") return false;

      this.$router.replace({
        path: resolvedRoute.path,
        query: resolvedRoute.query,
      });
      return true;
    },
    handleScroll() {
      if (this.isHomeRoute) {
        return;
      }
      if (!this.isWikiRoute && !this.$route.meta.transparentNav) {
        this.isScrolled = false;
        return;
      }
      const container = this.$refs.layoutRef;
      const scrollTop = container ? container.scrollTop : window.scrollY;
      this.isScrolled = scrollTop > 50;
    },
    handleHomeNavCompactChange(isCompact) {
      if (this.isHomeRoute) {
        this.homeNavCompact = Boolean(isCompact);
      }
    },
    resetCurrentHomeScroll() {
      if (!this.isHomeRoute) return;

      const pageView = this.$refs.pageView;
      const pageContainer =
        pageView?.scrollContainer || pageView?.$refs?.pchome;
      if (pageContainer) {
        pageContainer.scrollTop = 0;
      }

      const layoutContainer = this.$refs.layoutRef;
      if (layoutContainer) {
        layoutContainer.scrollTop = 0;
      }
      if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }

      this.homeNavCompact = false;
      this.isScrolled = false;
    },
    handleLogoClick() {
      this.$router.push("/pc/home");
    },
  },
};
</script>

<style lang="less" scoped>
.pc_out_container {
  width: 100%;
  height: 100vh;
  overflow-y: auto;

  .pc-account-link {
    &,
    &:visited,
    &:hover,
    &:focus,
    &:active {
      color: inherit !important;
      text-decoration: none !important;
    }
  }

  .pc-ui-locale {
    flex: 0 0 auto;
    margin-right: 12px;
    font-size: 12px;
    z-index: 100;
  }
  // 样式1
  .layout_top {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999 !important;
    box-shadow: none !important;
    border-bottom: none !important;
    transition: background 0.3s ease;
    &::after {
      display: none !important;
    }
    &::before {
      display: none !important;
    }

    &.home-edge-layout {
      .layout_top_text {
        width: calc(100% - 48px);
        max-width: none;

        .layout_top_text_inner {
          .nav-container {
            gap: 24px;
          }
        }
      }
    }

    &.home-compact {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0)
      ) !important;

      .nav-container .nav-item span,
      .nav-container .nav-item-dropdown,
      .nav-container .nav-item-dropdown .nav-item span {
        color: #ffffff !important;
        &:hover {
          color: rgba(255, 255, 255, 0.8) !important;
        }
      }

      .me.pc-login-area div span {
        color: #ffffff !important;
        font-size: 14px !important;
      }

      .me.pc-login-area
        div
        a.clickable:not(.pc-login-btn):not(.pc-register-btn) {
        color: #ffffff !important;
        font-size: 14px !important;
      }
    }

    &.wiki-scrolled {
      background: #ffffff !important;
      box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08) !important;
    }

    &.transparent-scrolled {
      background: #ffffff !important;
      box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08) !important;
    }

    &.is-wiki-nav {
      .nav-container {
        .nav-item {
          padding: 8px 16px;
          border-radius: 10px;

          span {
            font-size: 16px;
            font-weight: 600;
          }

          &:hover {
            background: rgba(24, 144, 255, 0.18);
          }

          &.active {
            background: transparent;

            span {
              font-size: 16px;

              &::after {
                display: block;
                background: #4286f5;
              }
            }
          }
        }
      }

      .pc-search-box ::v-deep .search-container {
        border: 2px solid #1890ff;
        box-shadow: none;
      }

      .layout_top_text .me.pc-login-area div span {
        color: #ffffff !important;
      }

      .layout_top_text
        .me.pc-login-area
        div
        a.clickable:not(.pc-login-btn):not(.pc-register-btn) {
        color: #ffffff !important;
      }

      .layout_top_text .me.pc-login-area .login-btns {
        border-color: rgba(255, 255, 255, 0.45) !important;
        background: transparent !important;
      }
    }

    .layout_top_text {
      width: calc(100% - 64px);
      max-width: 1760px;
      height: @pc-layout-height;
      margin: 0 auto;
      display: flex;
      align-items: center;
      border-bottom: none !important;
      box-shadow: none !important;
      &::after {
        display: none !important;
      }

      .layout_top_text_inner {
        display: flex;
        align-items: center;
        flex: 1 1 auto;
        min-width: 0;
        height: 100%;
        margin-right: 16px;
        .logo_img {
          flex: 0 0 auto;
          margin-right: clamp(24px, 4.5vw, 90px);
          z-index: 99;

          &.home-compact-logo {
            width: 180px;
            height: auto;
            object-fit: contain;
            cursor: pointer;
            transform: translateY(-13px);
          }
        }

        .nav-container {
          display: flex;
          align-items: center;
          flex: 0 1 auto;
          gap: clamp(18px, 2.8vw, 56px);
          min-width: 0;
          z-index: 99;

          .nav-item {
            cursor: pointer;
            padding: 5px 0;
            position: relative;
            transition: color 0.3s ease;
            span {
              font-size: 14px;
              font-weight: 400;
              white-space: nowrap;
              color: inherit;
              position: relative;
              &:hover {
                color: inherit !important;
                opacity: 0.85;
              }
            }
            &.active {
              span {
                color: inherit;
                font-weight: 700;
                font-size: 14px;
                &::after {
                  content: "";
                  position: absolute;
                  bottom: -5px;
                  left: 0;
                  right: 0;
                  height: 4px;
                  background: #4286f5;
                  border-radius: 2px;
                }
              }
            }

            &.no-active-indicator.active span::after {
              display: none;
            }
          }

          .nav-item-dropdown {
            position: relative;
            .nav-item {
              display: flex;
              align-items: center;
              span {
                color: inherit;
              }
              &:hover {
                color: inherit !important;
                opacity: 0.85;
              }
              &.active {
                color: inherit;
                font-weight: 700;
                font-size: 14px;
              }
            }
          }
        }
      }
      .pc-search-box {
        flex: 0 0 auto;
        margin-left: 32px;
        margin-right: 16px;
        z-index: 99;

        // 顶部搜索框统一宽度。
        ::v-deep .pc-top-search.search-container {
          width: 280px;
          height: 32px;
          padding: 3px 6px 3px 12px;
          border-radius: 16px;

          .search-input {
            height: 26px;
          }

          .search-btn {
            flex: 0 0 auto;
            width: auto;
            height: 26px;
            padding: 0 10px;
            color: #4286f5;
            font-size: 12px;
            font-weight: 400;
            white-space: nowrap;
          }
        }
      }
      .me.pc-login-area {
        flex: 0 0 auto;
        line-height: @pc-layout-height;
        white-space: nowrap;
        display: flex !important;
        align-items: center;
        justify-content: flex-end;
        margin-left: auto;

        div span {
          font-size: 14px !important;
          color: #3b3b3b !important;
          margin-right: 12px;
        }

        div a.clickable:not(.pc-login-btn):not(.pc-register-btn) {
          font-size: 14px !important;
          color: #4286f5 !important;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }

        .login-btns {
          display: inline-flex;
          align-items: center;
          gap: 0;
          height: 32px;
          overflow: hidden;
          box-sizing: border-box;
          border: 1px solid #e5e7eb;
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.82);
          transition:
            border-color 0.2s ease,
            background 0.2s ease;

          .pc-login-btn,
          .pc-register-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            height: 100% !important;
            margin-left: 0 !important;
            padding: 0 16px !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            color: #3b3b3b !important;
            font-size: 12px !important;
            font-weight: 400 !important;
            line-height: 1 !important;
            text-decoration: none;
            box-sizing: border-box !important;
            transition:
              color 0.2s ease,
              background 0.2s ease !important;

            &:hover {
              color: #4286f5 !important;
              background: rgba(66, 134, 245, 0.06) !important;
            }
          }

          .pc-register-btn {
            border-left: 1px solid #e5e7eb !important;
          }
        }
      }
    }
  }
  // 样式2-我的模块
  .layout_top_my {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999 !important;
    background: #ffffff !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    .layout_top_text {
      width: calc(100% - 64px);
      max-width: 1760px;
      height: @pc-layout-height;
      margin: 0 auto;
      display: flex;
      align-items: center;

      .layout_top_text_inner {
        display: flex;
        align-items: center;
        flex: 1 1 auto;
        min-width: 0;
        height: 100%;
        margin-right: 16px;

        .logo_img {
          flex: 0 0 auto;
          margin-right: clamp(24px, 4.5vw, 90px);
          z-index: 99;
          cursor: pointer;
          &.home-compact-logo {
            width: 180px;
            height: auto;
            object-fit: contain;
            cursor: pointer;
            transform: translateY(-13px);
          }
        }

        .nav-container {
          display: flex;
          align-items: center;
          flex: 0 1 auto;
          gap: clamp(18px, 2.8vw, 56px);
          min-width: 0;
          z-index: 99;

          .nav-item {
            cursor: pointer;
            padding: 5px 0;
            position: relative;
            transition: color 0.3s ease;
            span {
              font-size: 14px;
              font-weight: 400;
              white-space: nowrap;
              color: rgba(59, 59, 59, 0.8);
              position: relative;
              &:hover {
                color: rgba(59, 59, 59, 1) !important;
              }
            }
            &.active {
              span {
                color: rgba(59, 59, 59, 1);
                font-weight: 700;
                font-size: 14px;
                &::after {
                  content: "";
                  position: absolute;
                  bottom: -5px;
                  left: 0;
                  right: 0;
                  height: 4px;
                  background: #4286f5;
                  border-radius: 2px;
                }
              }
            }
          }

          .nav-item-dropdown {
            .nav-item {
              display: flex;
              align-items: center;
              span {
                color: rgba(59, 59, 59, 0.8);
              }
              &:hover {
                color: rgba(59, 59, 59, 1) !important;
              }
              &.active {
                color: rgba(59, 59, 59, 0.8);
                font-weight: 700;
                font-size: 14px;
              }
            }
          }
        }
      }
      .layout_top_text .me.pc-login-area {
        flex: 0 0 auto;
        line-height: @pc-layout-height;
        white-space: nowrap;
        display: flex !important;
        align-items: center;
        justify-content: flex-end;
        margin-left: 24px;

        div span {
          font-size: 14px !important;
          color: #3b3b3b !important;
          margin-right: 12px;
        }

        div a.clickable:not(.pc-login-btn):not(.pc-register-btn) {
          font-size: 14px !important;
          color: #4286f5 !important;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .layout_top_text .me.pc-login-area .login-btns {
        display: inline-flex;
        align-items: center;
        gap: 12px;
      }
      .layout_top_text .me.pc-login-area a.pc-login-btn,
      .layout_top_text .me.pc-login-area a.pc-register-btn {
        text-decoration: none;
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #3b3b3b !important;
        padding: 0 16px !important;
        border: 1px solid #e0e0e0 !important;
        background: #ffffff !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        margin-left: 0 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 32px !important;
        box-sizing: border-box !important;
        &:hover {
          color: #4286f5 !important;
          border-color: #4286f5 !important;
        }
      }

      .me.pc-login-area {
        flex: 0 0 auto;
        line-height: @pc-layout-height;
        white-space: nowrap;
        display: flex !important;
        align-items: center;
        justify-content: flex-end;
        margin-left: auto;

        div span {
          font-size: 14px !important;
          color: #3b3b3b !important;
          margin-right: 12px;
        }

        div a.clickable:not(.pc-login-btn):not(.pc-register-btn) {
          font-size: 14px !important;
          color: #4286f5 !important;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
      .me.pc-login-area .login-btns {
        display: inline-flex;
        align-items: center;
        gap: 12px;
      }

      .me.pc-login-area a.pc-login-btn,
      .me.pc-login-area a.pc-register-btn {
        text-decoration: none;
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #3b3b3b !important;
        padding: 0 16px !important;
        border: 1px solid #e0e0e0 !important;
        background: #ffffff !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        margin-left: 0 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 32px !important;
        box-sizing: border-box !important;

        &:hover {
          color: #4286f5 !important;
          border-color: #4286f5 !important;
        }
      }
    }
  }
}

.layout_top .nav-item.no-active-indicator.active span::after,
.layout_top_my .nav-item.no-active-indicator.active span::after {
  display: none !important;
}

.layout_top .nav-item.no-active-indicator.active span,
.layout_top_my .nav-item.no-active-indicator.active span {
  font-weight: 400 !important;
}
.logo_img.home-compact-logo.festival-nav-logo {
  width: 190px !important;
  height: 48px !important;
  max-height: 48px;
  margin-right: clamp(16px, 1.6vw, 26px) !important;
  object-fit: contain;
  object-position: left center;
  transform: none !important;
  animation: festivalNavBreath 3.2s ease-in-out infinite;
}

.logo_img.home-compact-logo.mid-autumn-nav-logo {
  filter: drop-shadow(0 3px 7px rgba(204, 146, 35, 0.18));
}

.logo_img.home-compact-logo.national-day-nav-logo {
  filter: drop-shadow(0 3px 7px rgba(193, 31, 34, 0.16));
}

@keyframes festivalNavBreath {
  0%,
  100% {
    opacity: 0.94;
  }
  50% {
    opacity: 1;
  }
}

@media (max-width: 1360px) {
  .logo_img.home-compact-logo.festival-nav-logo {
    width: 170px !important;
    height: 42px !important;
    max-height: 42px;
    margin-right: 14px !important;
  }
}
</style>
